/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthlytask_ClaimInputs */

const en_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim`)
};

const ar_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطالبة`)
};

const de_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhalte`)
};

const es_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamar`)
};

const fr_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir`)
};

const it_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta`)
};

const ja_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取る`)
};

const ko_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`받기`)
};

const pt_br_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindicar`)
};

const ru_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить`)
};

const th_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แลกรับ`)
};

const tr_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al`)
};

const zh_cn_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领取`)
};

const zh_tw_monthlytask_claim = /** @type {(inputs: Monthlytask_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領取`)
};

/**
* | output |
* | --- |
* | "Claim" |
*
* @param {Monthlytask_ClaimInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthlytask_claim = /** @type {((inputs?: Monthlytask_ClaimInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthlytask_ClaimInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthlytask_claim(inputs)
	if (locale === "ar") return ar_monthlytask_claim(inputs)
	if (locale === "de") return de_monthlytask_claim(inputs)
	if (locale === "es") return es_monthlytask_claim(inputs)
	if (locale === "fr") return fr_monthlytask_claim(inputs)
	if (locale === "it") return it_monthlytask_claim(inputs)
	if (locale === "ja") return ja_monthlytask_claim(inputs)
	if (locale === "ko") return ko_monthlytask_claim(inputs)
	if (locale === "pt_br") return pt_br_monthlytask_claim(inputs)
	if (locale === "ru") return ru_monthlytask_claim(inputs)
	if (locale === "th") return th_monthlytask_claim(inputs)
	if (locale === "tr") return tr_monthlytask_claim(inputs)
	if (locale === "zh_cn") return zh_cn_monthlytask_claim(inputs)
	return zh_tw_monthlytask_claim(inputs)
});